<template>
  <div id="checkout-page">
      <Checkout api="city-aventure-saintefoy"/>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>